import { REHYDRATE } from 'redux-persist'
import { List, Map, Record } from 'immutable'
// @ts-ignore
import { handleActions } from 'redux-actions'
import * as actions from './actions'

// eslint-disable-next-line no-unused-vars
import { ReviewsSurvey, ReviewsSurveyUsedBy } from 'store/records/reviewsSurveys'
import { ICompetencyQuestions, IOpenEndedQuestions, IQuestions, IReviewsSurvey } from './interfaces/reducer.interfaces'

export const ReviewsSurveys = Record(
  {
    list: List(),
    asking: Map({
      survey: new ReviewsSurvey(),
      answers: Map(),
    }),
  },
  'reviewsSurveys'
)

// const handleFlush = () => {
//   return new ReviewsSurveys()
// }

const handleRehydrate = (state: any, { payload }: any) => {
  return payload && payload.reviewsSurveys && payload.reviewsSurveys.set ? payload.reviewsSurveys : state
}

const convertDataToReviewsSurveyStructure = (reviewsSurvey: IReviewsSurvey) => {
  const preparedReviewsSurvey = {} as {
    openEndedQuestions: Map<string, any>
    competenciesQuestions: List<any>
  }
  const openEndedQuestions = JSON.parse(reviewsSurvey.openEndedQuestions) as IOpenEndedQuestions
  if (openEndedQuestions) {
    preparedReviewsSurvey.openEndedQuestions = Map({
      t1: List(
        openEndedQuestions.t1.map((questions: IQuestions) => {
          return Map({
            userQuestion: questions.userQuestion,
            reviewerQuestion: questions.reviewerQuestion,
          })
        })
      ),
      t2: List(
        openEndedQuestions.t2.map((questions: IQuestions) => {
          return Map({
            userQuestion: questions.userQuestion,
            reviewerQuestion: questions.reviewerQuestion,
          })
        })
      ),
    })
  }
  const competenciesQuestions = JSON.parse(reviewsSurvey.competenciesQuestions)
  preparedReviewsSurvey.competenciesQuestions = List(
    competenciesQuestions.map((competencyQuestions: ICompetencyQuestions) => {
      return Map({
        name: competencyQuestions.name,
        questions: List(
          competencyQuestions.questions.map((question: IQuestions) => {
            return Map({
              userQuestion: question.userQuestion,
              reviewerQuestion: question.reviewerQuestion,
            })
          })
        ),
      })
    })
  )
  return new ReviewsSurvey(
    Map({
      ...reviewsSurvey,
      ...preparedReviewsSurvey,
      organizationId: reviewsSurvey.organizationId,
      usedBy: new ReviewsSurveyUsedBy(Map(reviewsSurvey.usedBy)),
    })
  )
}

const handleFetchReviewsSurveysSuccess = (state: Map<string, any>, { payload: { data: reviewsSurveys } }: any) => {
  return state.set(
    'list',
    List(reviewsSurveys.map((reviewsSurvey: IReviewsSurvey) => convertDataToReviewsSurveyStructure(reviewsSurvey)))
  )
}

const handleUpdateReviewsSurveySuccess = (state: Map<string, any>, { payload: { data } }: any) => {
  const index = state.get('list').findIndex((reviewsSurvey: Map<string, any>) => {
    return reviewsSurvey.get('id') === data.id
  })
  return state.setIn(['list', index], convertDataToReviewsSurveyStructure(data))
}

const handleFetchReviewsSurveyByIdSuccess = (state: Map<string, any>, { payload: { data } }: any) => {
  return state.setIn(['asking', 'survey'], convertDataToReviewsSurveyStructure(data))
}

export default handleActions(
  {
    [REHYDRATE]: handleRehydrate,
    // [FLUSH]: handleFlush,
    [actions.fetchReviewsSurveys.success.toString()]: handleFetchReviewsSurveysSuccess,
    [actions.updateReviewsSurvey.success.toString()]: handleUpdateReviewsSurveySuccess,
    [actions.publishReviewsSurvey.success.toString()]: handleUpdateReviewsSurveySuccess,
    [actions.fetchReviewsSurveyById.success.toString()]: handleFetchReviewsSurveyByIdSuccess,
  },
  // @ts-ignore
  new ReviewsSurveys()
)
